import React from 'react';
import Alert from './Alert';
import FundingForecast from '../dashboards/FundingForecast/Dashboard';
import ESG from '../dashboards/ESG/Dashboard';
import InvestibleBenchmark from '../dashboards/InvestibleBenchmark/Dashboard';
import CashflowCoverage from '../dashboards/CashflowCoverage/Dashboard';

// TODO: Import these dynamically and purely based on config
const components = {
  'esg': ESG,
  'investible_benchmark': InvestibleBenchmark,
  'funding_forecast': FundingForecast,
  'cashflow_coverage': CashflowCoverage,
};

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    })
  }

  render() {
    if (this.state.errorInfo) {
      return <Alert
        title="Something went wrong"
        details={this.state.error && this.state.error.toString()}
        stackTrace={this.state.errorInfo.componentStack}
      />
    }

    if (this.props.error.isError) {
      console.error('Could not fetch data from %s', this.props.error.databaseUrl);
      return <Alert
        title={`Could not fetch data from ${this.props.error.databaseUrl}`}
        details={this.props.error.message}
      />
    }

    const Board = components[this.props.dashboard];

    return (
      <Board data={this.props.data} triggersEnabled={this.props.triggersEnabled} isLoading={this.props.isLoading} />
    );

  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Dashboard.js